var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginEllipse1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 214,
    viewBox: "0 0 196 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 162,
    cy: 52,
    r: 162,
    fill: "#F9A826"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginEllipse1);
export default __webpack_public_path__ + "static/media/login-ellipse-1.21fdd20c183a3e66c50d24a3adc5a999.svg";
export { ForwardRef as ReactComponent };